// <debug>
import { Operation } from '../Types';

class OperationError extends Error {
  constructor(message: string, operation?: Operation) {
    super(`${message}${OperationError.errorAtOperation(operation)}`);

    this.name = 'OperationError';
  }

  private static errorAtOperation(o: Operation): string {
    const err = JSON.stringify(o, null, 4);
    return `\nError at operation:\n${err}`;
  }
}

export default OperationError;
// </debug>
